<template>
  <div class="filter-container">
    <div class="grid-item">
      <!-- First row - Show All button only -->
      <div class="filter-row">
        <button
          :class="['buy', { buyActive: isActive('all') }]"
          @click="$emit('filter-change', 'all')"
        >
          <span class="white-text">Show All</span>
        </button>
      </div>

      <!-- Second row - Main filters -->
      <div class="filter-row">
        <button
          v-for="(filter, key) in topRowFilters"
          :key="key"
          :class="['buy', { buyActive: isActive(key) }]"
          @click="$emit('filter-change', key)"
        >
          <span class="white-text">{{ filter.label }}</span>
        </button>
      </div>

      <!-- <div class="filter-row">
        <button
          v-for="(filter, key) in topRowFilters"
          :key="key"
          :class="['buy', { buyActive: isActive(key) }]"
          @click="$emit('filter-change', key)"
        >
          <span class="white-text">{{ filter.label }}</span>
        </button>
      </div> -->

      <div class="filter-row">
        <button
          v-for="(filter, key) in middleRowFilters"
          :key="key"
          :class="['buy', { buyActive: isActive(key) }]"
          @click="$emit('filter-change', key)"
        >
          <span class="white-text">{{ filter.label }}</span>
        </button>
      </div>

      <div class="filter-row">
        <button
          v-for="(filter, key) in bottomRowFilters"
          :key="key"
          :class="['buy', 'wide-button', { buyActive: isActive(key) }]"
          @click="$emit('filter-change', key)"
        >
          <span class="white-text">{{ filter.label }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  activeFilter: {
    type: String,
    required: true,
  },
});

defineEmits(['filter-change']);

const topRowFilters = computed(() => ({
  bothDown: props.filters.bothDown,
  upAndMid: props.filters.upAndMid,
  upAndDown: props.filters.upAndDown,
  bothUp: props.filters.bothUp,
}));

const middleRowFilters = computed(() => ({
  bothUpWhiteUp: props.filters.bothUpWhiteUp,
  bothUpWhiteFront: props.filters.bothUpWhiteFront,
  bothUpWhiteSide: props.filters.bothUpWhiteSide,
}));

const bottomRowFilters = computed(() => ({
  bothUpWhiteUpBlock: props.filters.bothUpWhiteUpBlock,
  bothUpWhiteFrontBlock: props.filters.bothUpWhiteFrontBlock,
  bothUpWhiteRightBlock: props.filters.bothUpWhiteRightBlock,
}));

const isActive = (filterKey) => {
  return props.activeFilter === filterKey;
};
</script>

<style scoped>
.filter-container {
  margin-bottom: 10px;
}

.filter-row {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  justify-content: center; /* ← Add this line */
}

.buy {
  display: inline-block;
  height: 50px;
  font-size: 20px;
  line-height: 48px;
  text-align: center;
  background-color: #44a8f2;
  border: 2px solid #44a8f2;
  padding: 0 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.buy:hover {
  background-color: #fff;
  color: #44a8f2;
}

.buy:hover .white-text {
  color: #44a8f2;
}

.buyActive {
  background-color: navy;
}

.wide-button {
  width: 240px;
}

.white-text {
  color: #fff;
}
</style>
